import { makeStyles } from '@material-ui/core';
import React, { PropsWithChildren } from 'react';

type StyledCardProps = PropsWithChildren<{
  padding?: string;
  minHeight?: string;
}>;

const useStyles = makeStyles(theme => ({
  card: (props: StyledCardProps) => ({
    minHeight: props.minHeight || 500,
    padding: props.padding || theme.spacing(6, 4),
    boxShadow: '0px 2px 32px -8px rgba(30, 44, 66, 0.2)',
    borderRadius: 20,
    textAlign: 'center',
  }),
  cardIcon: {
    marginBottom: theme.spacing(2),
  },
}));

type StyledCardSeparatorProps = PropsWithChildren<{
  marginLeft?: string;
  width?: string;
}>;

const separatorStyles = makeStyles(theme => ({
  separator: (props: StyledCardSeparatorProps) => ({
    height: 3,
    backgroundColor: theme.palette.primary.main,
    borderRadius: 5,
    width: props.width || '50%',
    margin: theme.spacing(4, 0),
    marginLeft: props.marginLeft || 'auto',
    marginRight: 'auto',
  }),
}));

export const StyledCardSeparator: React.FC<StyledCardSeparatorProps> = (props: StyledCardSeparatorProps) => {
  const classes = separatorStyles(props);
  return <div className={classes.separator} />;
};

export const StyledCard: React.FC<StyledCardProps> = (props: StyledCardProps) => {
  const classes = useStyles(props);

  return <div className={classes.card}>{props.children}</div>;
};
